import React from 'react';
import { Card } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import DepartmentManagementList from './DepartmentManagementList';

const DepartmentManagement = () => {
  return (
    <div className="department-management-container">
      <Card 
        className="department-management-main-card"
        style={{ 
          borderRadius: '12px',
          boxShadow: 'none',
          margin: '0',
          width: '100%'
        }}
      >
        <DepartmentManagementList />
      </Card>
    </div>
  );
};

export default DepartmentManagement;
